const NAME = "CLOCK";

export default NAME;
